<template>
  <AuthWrongBase>
    <router-link :to="{ name: 'Register' }">
      <p>
        Lo sentimos, pero el email con el que intentas acceder no se encuentra
        en el listado de asistentes. Por favor, asegúrate de que lo estás
        escribiendo correctamente.
      </p>
      <p class="mt-4">
        Si lo deseas, puedes acceder al
        <span class="font-bold hover:underline">formulario de registro</span>
        para acceder a la conferencia.
      </p>
    </router-link>
  </AuthWrongBase>
</template>

<script>
import AuthWrongBase from '@/components/AuthWrongBase'

export default {
  components: { AuthWrongBase },
}
</script>
